<section aria-labelledby="section-title">
  <div class="row">
    <div class="col-sm-10 col-md-8 col-lg-6 mx-auto ">
      <h1 id="section-title">{{ 'DIPRSRegistration.existing.account.title' | translate }}</h1>
      <p class="text-center"
         [innerHTML]="'DIPRSRegistration.existing.account.description' | translate : {url: resetPasswordUrl}"></p>
      <div class="row td-toolbar">
        <div class="col-sm-6 mx-auto text-center">
          <button type="button" (click)="goToMyInsuranceLoginPage()" class="btn btn-block td-btn-primary-light">
            {{ 'DIPRSRegistration.existing.account.btn' | translate }}
          </button>
          <div class="mt-50">
            <small>
              <span *ngIf="sessionId">SID: {{sessionId}}</span>
              <br>
              <span *ngIf="version">VERSION: {{version}}</span>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
